
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"57","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"27","cy":"29","r":"27","fill":"#FF631C"}}),_c('path',{attrs:{"d":"M18.606 22.582h5.016c0-2.242 1.368-3.572 3.686-3.572 2.242 0 3.61 1.368 3.61 3.572.038 3.42-2.926 4.142-6.878 4.142h-1.71l.19 6.46h4.674l.152-2.926c5.054 0 8.74-2.508 8.74-7.638s-3.61-8.056-8.778-8.056c-5.548 0-8.778 3.42-8.702 8.018zm9.462 16.568c0-1.748-1.368-3.116-3.23-3.116-1.938 0-3.306 1.368-3.306 3.116s1.368 3.116 3.306 3.116c1.862 0 3.23-1.368 3.23-3.116z","fill":"#fff"}})])
          )
        }
      }
    